<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
// import axios from "axios"
export default {
  data() {
    return {};
  },
  methods: {
    exit() {
      console.log("exit");
      // axios('config.json').then(res=>{
        // const baseURL = res.data.baseURL
        localStorage.getItem("userInfo") && localStorage.removeItem("userInfo");
        localStorage.getItem("queryTime") && localStorage.removeItem("queryTime");
        localStorage.getItem("selectStore") && localStorage.removeItem("selectStore");
        localStorage.getItem("result") && localStorage.removeItem("result");
        localStorage.getItem("username") && localStorage.removeItem("username");
        window.location = "/dist/login.html"
      // })
    },
  },
  mounted() {
    window.addEventListener("beforeunload", () => {
      !localStorage.getItem("dev") && this.exit();
    });
  },
  // destroyed() {
  //   window.removeEventListener("beforeunload", () => {
  //     localStorage.removeItem("queryTime");
  //   });
  // },
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  list-style: none;
  // font-family: "SourceHanSans";
  -webkit-user-drag: none;
}
.el-picker-panel.el-date-picker.el-popper {
  .el-date-table__row {
    .available.today {
      span {
        color: #606266;
        background-color: rgba($color: #fdcb9e, $alpha: 0.25);
        border-radius: 2px;
      }
    }
    .available.current {
      span {
        background-color: #fdcb9e;
        color: #000;
        border-radius: 2px;
      }
    }
  }
}
.el-picker-panel__footer button:first-child {
  display: none;
}
.el-picker-panel__footer {
  display: flex;
  justify-content: center;
}
.el-picker-panel__footer button {
  width: 100%;
  border: none;
  background-color: rgba($color: #000000, $alpha: 0);
}
.el-select-dropdown__item.selected,
.el-picker-panel__icon-btn:hover,
.el-date-picker__header-label:hover,
.el-date-table td.available:hover,
.el-year-table td .cell:hover,
.el-month-table td .cell:hover,
.el-year-table td.today .cell,
.el-month-table td.current:not(.disabled) .cell,
.el-month-table td.today .cell {
  color: #fdcb9e;
}
.el-input__inner {
  outline: none;
}
.el-time-panel__btn.confirm {
  color: #fdcb9e;
}
.el-popover {
  min-width: 100px;
}
.el-popover ul {
  font-size: 16px;
  border-top: 1px solid rgba($color: #000000, $alpha: 0.2);
  padding-top: 10px;
}
.el-popover li {
  padding: 3px 0;
  cursor: pointer;
}
.el-popover li:hover {
  background-color: #f5f7fa;
}
.el-popover__title {
  word-break: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
}
.el-checkbox__inner {
  width: 24px;
  height: 24px;
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: rgba(253, 203, 158, 1);
  border-color: rgba(253, 203, 158, 1);
  width: 24px;
  height: 24px;
}
.el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
  left: 1px;
  top: 10px;
}
.el-checkbox__inner::after {
  border-width: 3px;
  height: 11px;
  left: 9px;
  top: 2px;
  width: 4px;
}
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #f5f7fa;
  color: #000;
}
</style>
